import apiHelper from '@api/helper'
import constants from '@/services/constants'
import { AUTH_REQUEST, AUTH_LOADING } from '@/store/actions/auth'
import store from '@store'
const state = {
  error_rmr_items: {
    surplus: [],
    courtesy: [],
    disposal: [],
    repair_return: []
  },
  selected_rmr_header: {},
  rmr_item: [],
  current_exchange_rate: {},
  get_rmr_form: {},
  rmr_action: {},
  rmr_view_mode: false,
  current_return_type: -1,
  mfd_attach: [],
  get_partner_share: [],
  invoice_header: {},
  invoice_items: [],
  mfd_action_state: {},
  inventory_write_off_bach_no_state: [],
  flag_support_document: false,
  issue_attachment: [],
  rmr_header: {},
  receive_material_header: {},
  receive_attachment: [],
  refurbished_material_header: {}
}

const getters = {
  errorTabRmrItems (state) {
    return state.error_rmr_items
  },
  selectedRmrHeader () {
    return state.selected_rmr_header
  },
  invoiceHeader () {
    return state.invoice_header
  },
  invoiceItems () {
    return state.invoice_items
  },
  rmrItems () {
    return state.rmr_item
  },
  currentExchangeRate () {
    return state.current_exchange_rate
  },
  getRmrForm () {
    return state.get_rmr_form
  },
  rmrViewMode() {
    return state.rmr_view_mode
  },
  rmrAction() {
    return state.rmr_action
  },
  currentReturnType () {
    return state.current_return_type
  },
  mfdAttach () {
    return state.mfd_attach
  },
  getPartnerShare () {
    return state.get_partner_share
  },
  getMfdActionState() {
    return state.mfd_action_state
  },
  getInventoryWriteOffBachNoState () {
    return state.inventory_write_off_bach_no_state
  },
  getFlagSupportDocument () {
    return state.flag_support_document
  },
  getIssueAttachment () {
    return state.issue_attachment
  },
  getRmrHeader() {
    return state.rmr_header
  },
  getReceiveMaterialHeader() {
    return state.receive_material_header
  },
  getReceiveAttachment () {
    return state.receive_attachment
  },
  getRefurbishedMaterialHeader() {
    return state.refurbished_material_header
  },
}

const actions = {
  'SAVE_RMR': ({commit, dispatch}, payload) => {
    return new Promise((resolve, reject) => {
      // adding command to set loading : true
      dispatch('toggleLoading', true)
      apiHelper.material.saveRmr(payload.id, payload).then(resp => {
        if (resp.data.responseStatus.responseCode === 'SUCCESS') {
          dispatch('toggleLoading', false)

          resolve(resp)
        } else {
          dispatch('toggleLoading', false)

          reject(resp)
        }
      }).catch(error => {
        dispatch('toggleLoading', false)
        reject(error)
      })
    })
  },
  'SAVE_RMR_ITEM': async ({commit, dispatch}, payload) => {
    try {
      let response = (await apiHelper.material.saveRmrItem(payload.id, payload)).data
      return response
    } catch (err) {
      console.error('---> SAVE_RMR_ITEM:', error)
    } finally {

    }
  },
  'ADD_RMR_ITEM': async ({commit, dispatch}, payload) => {
    try {
      let response = (await apiHelper.material.createRmrItem(payload)).data
      return response
    } catch (err) {
      console.error('---> ADD_RMR_ITEM:', error)
    } finally {

    }
  },
  'REMOVE_RMR_ITEM': async ({commit, dispatch}, payload) => {
    try {
      let response = (await apiHelper.material.removeRmrItem(payload)).data
      return response
    } catch (err) {
      console.error('---> REMOVE_RMR_ITEM:', error)
    } finally {

    }
  },
  'ADD_RMR_ATTACHMENT': async ({commit, dispatch}, payload) => {
    try {
      let response = (await apiHelper.material.createRmrAttachment(payload)).data
      return response
    } catch (err) {
      console.error('---> ADD_RMR_ATTACHMENT:', error)
    } finally {

    }
  },
  'REMOVE_RMR_ATTACHMENT': async ({commit, dispatch}, payload) => {
    try {
      let response = (await apiHelper.material.removeRmrAttachment(payload)).data
      return response
    } catch (err) {
      console.error('---> REMOVE_RMR_ATTACHMENT:', error)
    } finally {

    }
  },
  'CALCULATE_TOTAL_COST' : ({commit, dispatch}, payload) => {
    let total = {
      thb: 0,
      usd: 0,
      reviewUsd: 0,
      reviewThb: 0
    }
    if(payload.Quantity) {
      let qty = payload.Quantity
      if(payload.UnitCostUsd) {
        let cost = payload.UnitCostUsd
        total.usd = (qty * cost)
      }

      if(payload.UnitCostThb) {
        let cost = payload.UnitCostThb
        total.thb = (qty * cost)
      }
    }
    if(payload.ReceivedQTY) {
      let qty = payload.ReceivedQTY
      if(payload.ReviewUnitCostUsd) {
        let cost = payload.ReviewUnitCostUsd
        total.reviewUsd = (qty * cost)
      }

      if(payload.ReviewUnitCostThb) {
        let cost = payload.ReviewUnitCostThb
        total.reviewThb = (qty * cost)
      }
    }
    return total
  },
  'CALCULATE_TOTAL_WEIGHT' : ({commit, dispatch}, payload) => {
    let total = {
      return : 0,
      review: 0
    }
    let returnWeight = payload.UnitWeight ? payload.UnitWeight : 0
    let reviewWeight = payload.ReviewUnitWeight ? payload.ReviewUnitWeight : 0
    let returnQty = payload.Quantity ? payload.Quantity : 0
    let reviewQty = payload.ReceivedQTY ? payload.ReceivedQTY : 0
   
    total.review =  (reviewWeight * reviewQty)
    total.return =  (returnWeight * returnQty)
    return total
  },
  'UPDATE_VALIDATE_RMR_ITEM_ERROR' :  async ({commit, dispatch}, payload) => {
    if(!payload) {
      await commit('mutationClearErrorRmrItems', {})
    }
    else {
      await commit('mutationErrorRmrItems',payload)
    }
  },
  'SELECTED_RMR_HEADER' : ({commit, dispatch}, payload) => {
    commit('mutationSelectedRmrHeader', payload)
  },
  'SET_RMR_ITEM' : ({commit, dispatch}, payload) => {
    if(payload.action === 'init')
      commit('mutationInitRmrItem', payload.items)
    if(payload.action === 'add')
      commit('mutationAddRmrItem', payload.row)
    if(payload.action === 'update')
      commit('mutationUpdateRmrItem', payload.row)
    if(payload.action === 'remove')
      commit('mutationRemoveRmrItem', payload.row)
  },
  'SET_EXCHANGE_RATE' : async ({commit, dispatch}, payload) => {
    try {
      let res = (await apiHelper.master.getExchangeRateTop()).data
      if(res.responseStatus.responseCode === 'SUCCESS') { 
        let exchangeRate = res.responseData
        commit('mutationCurrentExchangeRate', exchangeRate)
      }
    } catch (e) {
      console.error('setexchange rate is error', e)
    }
  },
  'CONVERT_EXCHANGE_RATE' : async ({commit, dispatch}, payload) => {
    let usd = payload.usd
    let thb = payload.thb
    let currency = {
      thb: 0,
      usd: 0
    }
    let exchange = state.current_exchange_rate
    if(thb)
      currency.usd =  (thb / exchange.UsdPerThb)
    if(usd)
      currency.thb =   (usd / exchange.ThbPerUsd)
    return currency
  },
  'VALIDATE_ATTACHMENT_FILE':  async ({commit, dispatch}, payload) => {
    let errorList = []
    let files = payload.files
    let row = payload.row
    for (let file of files) {
      let descriptions = []
      if (!/\.(jpeg|jpe|jpg|gif|png)$/i.test(file.name)) {
        descriptions.push(`incorrect file format. Please select file jpg or png`)
      }
      let maxAttachmentSize = 5e+6 
      if(file.size > maxAttachmentSize) {
        descriptions.push(`incorrect file size. file size limit exceeded (5 MB)`)
      }
      let countUplodaFile = files.length
      let countCurrentFile = 0
      if(Array.isArray(row.Attachment))
        countCurrentFile = row.Attachment.length
      if((countCurrentFile + countUplodaFile) > 3) { // validate max file
        descriptions.push(`Uploaded photo is limited to 3 items, please delete one or more photo before upload a new photo.`)
      }

      if(descriptions.length > 0) {
        descriptions.forEach(o => {
          if(!errorList.some(x => x === o))
          errorList.push(o)
        })
      }
    }
    return errorList
  },
  'GET_RMR_FORM' : ({commit, dispatch}, payload) => {
    commit('mutationGetRmrForm', payload)
  },
  'SET_CURRENT_RETURN_TYPE' : ({commit, dispatch}, payload) => {
    commit('mutationSetCurrentReturnType', payload)
  },
  'GET_ITEM_NAMETH': async ({commit, dispatch}, payload) => {
    try {
      let res = (await apiHelper.master.searchDictionary(payload)).data
      if(res.responseStatus.responseCode === 'SUCCESS') {
        let data = res.responseData
        return data.thaiWord 
      }
    } catch(e) {
      console.error('get name th error ', e)
    } finally {
      return ''
    }
  },
  'GET_MFD_ATTACH' : ({commit, dispatch}, payload) => {
    commit('mutationGetMfdAttach', payload)
  },
  'FLAG_READ_MFD_COMMENT_REFER_USER' : async ({commit, dispatch}, payload) => {
    try {
      let res = (await apiHelper.material.flagIsReadMfdCommentToUser(payload)).data
      if(res.responseStatus.responseCode === 'SUCCESS') {
        console.info('flag is read comment refet to user success')
      }
     } catch(e) {
      console.error('get name th error ', e)
    }
  },
  'GET_AFE': async ({commit, dispatch}, payload) => {
    try {
      let res = (await apiHelper.master.getJdeAfeByAfeNo(payload)).data
      if(res.responseStatus.responseCode === 'SUCCESS') {
        return res.responseData
      }
     } catch(e) {
      console.error('get afe  error ', e)
      return {}
    }
  },
  'GET_PARTNER_SHARE' : ({commit, dispatch}, payload) => {
    commit('mutationGetPartnerShare', payload)
  },
  'GET_INVOICE_HEADER' : ({commit, dispatch}, payload) => {
    commit('mutationGetInvoiceHeader', payload)
  },
  'GET_INVOICE_ITEMS' : ({commit, dispatch}, payload) => {
    commit('mutationGetInvoiceItems', payload)
  },
  'SET_MFD_STATE' : ({commit, dispatch}, payload) => {
    commit('mutationSetMfdActionState', payload)
  },
  'SET_INVENTORY_WRITE_OFF_BACH_NO_STATE' : ({commit, dispatch}, payload) => {
    commit('mutationSetInventoryWriteOffBachNoState', payload)
  },
  'SET_FLAG_SUPPORT_DOCUMENT' : ({commit, dispatch}, payload) => {
    commit('mutationSetFlagSupportDocument', payload)
  },
  'GET_ISSUE_ATTACHMENT' : ({commit, dispatch}, payload) => {
    commit('mutationGetIssueAttachment', payload)
  },
  'GET_RMR_HEADER' : ({commit, dispatch}, payload) => {
    commit('mutationGetRmrHeader', payload)
  },
  'GET_RECEIVE_MATERIAL_HEADER' : ({commit, dispatch}, payload) => {
    commit('mutationGetReceiveMaterialHeader', payload)
  },
  'GET_RECEIVE_ATTACHMENT' : ({commit, dispatch}, payload) => {
    commit('mutationGetReceiveAttachment', payload)
  },
  'GET_REFURBISHED_MATERIAL_HEADER': async ({commit, dispatch}, payload) => {
    commit('mutationGetRefurbishedMaterialHeader', payload)
  },
}

const mutations  = {
  mutationErrorRmrItems (state, payload) {
    state.error_rmr_items[payload.type] = payload.errors
  },
  mutationClearErrorRmrItems(state, payload) {
    state.error_rmr_items = {
      surplus: [],
      courtesy: [],
      disposal: [],
      repair_return: []
    }
  },
  mutationGetInvoiceHeader (state, payload) {
    state.invoice_header = payload
  },
  mutationGetInvoiceItems (state, payload) {
    state.invoice_items = payload
  },
  mutationSelectedRmrHeader (state, payload) {
    state.selected_rmr_header = payload
  },
  mutationInitRmrItem(state, payload) {
    state.rmr_item = payload
  },
  mutationAddRmrItem (state, payload) {
    state.rmr_item.push(payload)
  },
  mutationUpdateRmrItem (state, payload) {
    let index = state.rmr_item.findIndex(o => o.RmrItemId === payload.RmrItemId)
    if(index > -1) {
      state.rmr_item[index] = payload
    }
  },
  mutationRemoveRmrItem (state, payload) {
    let index = state.rmr_item.findIndex(o => o.RmrItemId === payload.RmrItemId)
    if(index > -1) {
      state.rmr_item.splice(index, 1)
    }
  },
  mutationCurrentExchangeRate(state, payload) {
    state.current_exchange_rate = payload
  },
  mutationGetRmrForm (state, payload) {
   
    let passport = store.getters.passport
    let status = payload.header.Status
    let requester = payload.header.Requester
    let approver = payload.header.Approver
    let isDrafts =  status === constants.RMR_STATUS.DRAFTS
    let isWithdraw =  status === constants.RMR_STATUS.WITHDRAW
    let isCancel=  status === constants.RMR_STATUS.CANCEL
    let isApprove = status === constants.RMR_STATUS.APPROVE
    let isSubmit = status === constants.RMR_STATUS.SUBMIT
    let isReject = status === constants.RMR_STATUS.REJECT
    console.error('payload.header' , payload.header, passport.emailGroups.indexOf(approver))
    let isApprover = ((approver === passport.upn) || (passport.emailGroups.indexOf(approver) > -1))
    let isRequester = requester === passport.upn
    let isAdmin = passport.isAdmin
    let isInventorySpecialist = passport.isInventorySpecialist

    let isViewMode = true
    let statusCanEdit = (isDrafts || isWithdraw || isReject) && !isCancel
    let userRoleCanEdit = (isRequester || isAdmin || isInventorySpecialist)
    // console.error('isDrafts = ' , isDrafts, 'isWithdraw', isWithdraw , 'isReject', isReject, 'isCancel', isCancel)
    // console.error('isRequester' , isRequester, 'isAdmin' , isAdmin, 'isInventorySpecialist' ,isInventorySpecialist)
    // console.error('statusCanEdit', statusCanEdit, ' userRoleCanEdit ', userRoleCanEdit)
    if(statusCanEdit && userRoleCanEdit) {
      isViewMode = false
    }
    state.rmr_view_mode = isViewMode
    state.rmr_action = {
      isDrafts: isDrafts,
      isSubmit: isSubmit,
      isApprove: isApprove,
      isWithdraw: isWithdraw,
      isCancel: isCancel,
      isRequester: isRequester,
      isApprover: isApprover,
      isReject: isReject
    }
    state.get_rmr_form = payload
  },
  mutationSetCurrentReturnType(state, payload) {
    state.current_return_type = payload
  },
  mutationGetMfdAttach (state, payload) {
    state.mfd_attach = payload
  },
  mutationGetPartnerShare (state, payload) {
    state.get_partner_share = payload
  },
  mutationSetMfdActionState (state, payload) {
    state.mfd_action_state = payload
  },
  mutationSetInventoryWriteOffBachNoState (state, payload) {
    state.inventory_write_off_bach_no_state = payload
  },
  mutationSetFlagSupportDocument (state, payload) {
    state.flag_support_document = payload
  },
  mutationGetIssueAttachment (state, payload) {
    state.issue_attachment = payload
  },
  mutationGetRmrHeader (state, payload) {
    state.rmr_header = payload
  },
  mutationGetReceiveMaterialHeader (state, payload) {
    state.receive_material_header = payload
  },
  mutationGetReceiveAttachment(state, payload) {
    state.receive_attachment = payload
  },
  mutationGetRefurbishedMaterialHeader(state, payload) {
    state.refurbished_material_header = payload
  }
}

export default {
  actions, 
  getters, 
  state, 
  mutations
}
